<template>
  <div class="Modal">
    <div class="titulo">
      <p class="titulo__p">
        Welcome to the Online Consulting Management System
      </p>
    </div>
    <font-awesome-icon
      class="icon-title general-title"
      icon="times"
      @click="close"
    />
    <div class="contenido">
      <p class="contenido__p">
        In this interface you can view the progress of your project or
        consultancy, which is subdivided into
        <span class="resaltado">Phases and Processes;</span> the latter is
        divided into four items:
        <span>Description, Overview, Inputs and Deliverables</span>, schematized
        according to the requirement.
      </p>
      <p class="contenido__p">
        During the development of the consultancy or project, each process
        begins with a brief <span class="resaltado">Description</span> of it and
        continues with an <span class="resaltado">Overview</span> tab, in which
        it is intended to provide the client with help to streamline the
        process. Next, tabs of <span class="resaltado">Input</span> data and
        <span class="resaltado">Deliverables</span> allow the client and
        consultant to send and receive data and information as input to be
        analyzed, as well as the deliverable (s) in each process.
      </p>
      <p class="contenido__p">
        The management system aims to make the consultancy as efficient as
        possible; thus, when the client requires it, or better yet, at the end
        of each process, it is possible to
        <span class="resaltado">schedule a meeting </span> with the expert
        consultant to discuss methodologies, analysis and results. It is
        recommended that this meeting take place after the information has been
        delivered to the consultant in the <strong>input tap</strong> and he has
        had time to review it.
      </p>
      <p class="contenido__p">
        An in-system tool allows you to view the hours where the consultant is
        available to interact with the client and you can schedule the
        appointment in the same system. A notification in the calendar and in
        your email will inform you the date, time and link for the interaction.
      </p>
      <p class="contenido__p">
        <span class="resaltado">
          At all times a record is kept of the consulting time</span
        >, interaction with the consultant, hours required by the consultant for
        the analysis and the reports generated from such analysis and
        interaction with the client.
      </p>
      <br />
      <p class="contenido__p">
        Note: The phases and processes described in this project: Design and
        Operation for Hydraulic Fracturing, were based on the EGEP consultants
        experience and on the following references:
      </p>
      <p class="contenido__p">
        Miskimins J. (2019)
        <i>Hydraulic Fracturing Fundamentals and Advancements. </i>First
        Edition, Monograph Series, Society of Petroleum Engineers.
      </p>
      <p class="contenido__p">
        Ahmed, et al. (2016)
        <i
          >Unconventional Oil & Gas Resources - Exploitation and Development.
        </i>
        First Edition. Baker Hughes
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
<style scoped>
.Modal {
  background: white;
  box-shadow: 0px 0px 15px 1px #707070;
  height: 100%;
  border-radius: 10px;
  padding: 20px;
  position: relative;
}
.titulo__p {
  text-align: center;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 30px;
  margin: 30px;
}
.contenido__p {
  font-family: PT Sans, sans-serif;
  font-weight: 500;
  margin: 10px;
  font-size: 20px;
}
.resaltado {
  color: #f68b23;
}
.general-title {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 25px;
  color: #f68b23;
}
@media (max-width: 600px) {
  .titulo__p {
    font-size: 20px;
  }
  .contenido__p {
    font-size: 15px;
  }
}
</style>